import { Typography } from "@mui/material";
import EventsTable from "./table/eventsTable";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import getApiData from "../../../../hooks/apiRequests/getRequest";

const Events =  () => {
    const [data, setData] = useState([]);
//   const [searchParams, setSearchParams] = useState({
//     query: "",
//     page: "1",
//     pageSize: "20", // optional
//   });

  const navigate = useNavigate();

  // Initial load
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getApiData(`/Sent/Search?page_number=1&page_size=20`);
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [navigate]);

//   // Pagination + Search callback
//   const newpage = async (page, search) => {
//     const update = {
//       query: search ?? searchParams.query,
//       page: page?.toString() ?? "1",
//       pageSize: searchParams.pageSize
//     };

//     setSearchParams(update);

//     try {
//       const response = await getApiData(
//         `/Sent/Search?Search_filter=${update.query}&page_number=${update.page}&page_size=${update.pageSize}`
//       );
//       setData(response.data);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };
    return(
        <>
            <Typography variant="h5" component="div" sx={{ p: 2, color: 'black'}}>
                Company Events
            </Typography>
            <EventsTable eventList={data}/>
        </>
    );
};
export default Events;